export enum KullanilacakDilekceler {
    ilamsiz_tazyik_dilekcesi = 147,
    ilamli_tazyik_dilekcesi = 148,

}


